import { isFinite, toNumber } from "lodash-es";

export const toFixed = (unit: string | number, fixedPoints = 2) => {
  const unitAsNumber = toNumber(unit);
  const floorNumber = fixedPoints === 0 ? Math.floor(unitAsNumber) : unitAsNumber;
  const finiteUnit = isFinite(floorNumber) ? floorNumber : 0;
  return finiteUnit.toFixed(fixedPoints);
};
